<template>
    <div>
        <div class="title">Zresetuj swoje hasło</div>
    
        <div class="message has-icon is-info" v-if="showForm">
            <div class="message-body has-text-weight-semibold">
            <span class="icon"><i class="far fa-info-circle"></i></span>
                <p>Aby rozpocząć procedurę resetowania hasła do Viessmann PRO podaj swój login oraz powiązany z nim adres e-mail.</p>
            </div>
        </div>

        <div class="message has-icon is-success" :class="{'is-hidden': !isSuccess}">
            <div class="message-body has-text-weight-semibold">
            <span class="icon"><i class="far fa-smile"></i></span>
                <p class="is-size-5 has-margin-bottom less">Wysłaliśmy do Ciebie wiadomość!</p>
                <p>W celu ukończenia procedury resetowania hasła sprawdź swoją skrzynkę e-mail i postępuj zgodnie z instrukcją, którą w niej znajdziesz. Pamiętaj, że czasem wiadomości trafiają do folderu ze spamem. Nie zapomnij poszukać również w nim.</p>
            </div>
        </div>

        <error-message :msg="errorMsg"></error-message>

        <fieldset :class="{'is-loading': isLoading}" v-if="showForm">
            <form @submit.prevent="resetPassword">
                <validated-field label="Login" :validation="validation.login">
                    <input type="text" class="input" v-model="login">
                </validated-field>
                
                <div class="field">
                    <label class="label">E-mail</label>
                    <div class="control">
                        <input type="email" class="input" v-model="email">
                    </div>
                </div>
                
                <button type="submit" class="button is-fullwidth is-medium is-dark" :disabled="!canSubmit">Zresetuj hasło</button>
            </form>
        </fieldset>
    </div>
</template>

<script>
export default {
    components: {
        ErrorMessage: () => import("@/components/ErrorMessage.vue"),
        ValidatedField: () => import("@/components/forms/ValidatedField.vue")
    },
    computed: {
        canSubmit() {
            return this.login.length && this.email.length
        }
    },
    data() {
        return {
            showForm: true,
            isLoading: false,
            errorMsg: null,
            isSuccess: false,
            login: '',
            email: '',
            validation: {}
        }
    },
    methods: {
        resetPassword() {
            this.validation = {}
            this.isLoading = true;
            this.errorMsg = null;
            this.axios.post("/sendResetPasswordLink", 
            {
                "email": this.email,
                "login": this.login
            })
            .then(() => {
                this.isSuccess = true;
                this.showForm = false;
            })
            .catch((error) => {
                if(error.response.data.validation) {
                    this.validation = error.response.data.validation;
                    return;
                }
                this.errorMsg = error.response.data.message;
            })
            .finally(() => {
                this.isLoading = false;
            })
        }
    }
}
</script>